import type { RedirectHandler } from "../types";

export const createParamsResetHandler = (stateNames: readonly string[]): RedirectHandler => (transition) => {
    const fromState = transition.from();
    const toState = transition.to();

    if (!fromState.name) {
        return;
    }

    const fromStateName = fromState.name as (typeof stateNames)[number];
    const toStateName = toState.name as (typeof stateNames)[number];

    // Check if this is a redirected transition (meaning we already processed it)
    const redirectedFrom = transition.redirectedFrom();
    if (redirectedFrom) {
        // This is the second transition after our redirect, don't process again
        return;
    }

    if (!stateNames.includes(fromStateName) && stateNames.includes(toStateName)) {
        const params = transition.params();

        // Clear ALL params to avoid compatibility issues
        const clearedParams = Object.keys(params).reduce(
            (acc, key) => {
                acc[key] = undefined;
                return acc;
            },
            {} as Record<string, undefined>,
        );

        return {
            params: clearedParams,
        };
    }

    return;
};
